import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';
import { withRouteParams } from '@wheelbox/lithejs-router';

import withPageTitle from '../../../lib/page';

import FormsExample from './forms';
import RoutingExample from './routing';
import I18nExample from './i18n';

const ExamplePage: LitheFC = ({
  id = 'examples-page',
  testId = 'examples-page',
}): LitheElement<'main'> => {
  const { example } = withRouteParams();
  withPageTitle('LitheJS | Examples');

  return [
    'main',
    { id, 'data-testid': testId, class: 'page-grid p-4' },
    {
      forms: FormsExample({}),
      i18n: I18nExample({}),
      routing: RoutingExample({}),
    }[example],
  ];
};

export default ExamplePage;
